import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { DropDownList, getPlatformLogo, merchantSelectors, MixedMerchantDetails, useSelector } from "swiipe.portal.shared"
import { removeSchemeFromHostName } from "../../services/merchantService"
import { useRequiredUserRelations } from "../../services/userRelationService"
import { setSelectedWebshopIdThunk } from "../../store/thunks/merchantThunks"
import { useReduxDispatch } from "../../store/useReduxDispatch"
import LinkButton from "../buttons/LinkButton"
import "./WebshopSelect.scss"

interface IWebshopSelectProps {
    merchantDetails: MixedMerchantDetails
    onWebshopChange?: (selectedWebshopId: string) => void
    hidePlatform?: boolean
    hint?: string
    actionLink?: { title: string; href: string; target?: React.HTMLAttributeAnchorTarget }
}

const WebshopSelect = ({ merchantDetails, onWebshopChange, hint, hidePlatform, actionLink }: IWebshopSelectProps) => {
    const dispatch = useReduxDispatch()
    const { t } = useTranslation()

    useRequiredUserRelations([{ requiredType: "Merchant" }])

    const selectedWebshopId = useSelector(merchantSelectors.selectedWebshopId)
    const selectedPlatform = selectedWebshopId
        ? merchantDetails.webshops.find((w) => w.webshopId === selectedWebshopId)?.platform
        : undefined

    useEffect(() => {
        if (selectedWebshopId) {
            onWebshopChange?.(selectedWebshopId)
        }
    }, [selectedWebshopId])

    return (
        <div id="webshop-select-comp">
            <div className="webshop-select">
                <p className="heading mb-2" data-html2canvas-ignore>
                    {t("webshopselect.selectwebshop")}
                </p>
                <DropDownList
                    options={merchantDetails.webshops.map((w) => {
                        return { text: removeSchemeFromHostName(w.hostName), value: w.webshopId }
                    })}
                    onChange={(e) => {
                        localStorage[merchantDetails.swMerchant.swMerchantId + "_selectedWebshopId"] = e.target.value
                        dispatch(setSelectedWebshopIdThunk(merchantDetails.swMerchant.swMerchantId, e.target.value))
                    }}
                    value={selectedWebshopId}
                />
                {!hidePlatform && <img className="platform-logo" src={getPlatformLogo(selectedPlatform)} />}
            </div>
            {hint && (
                <div className="hint-webshop-select">
                    <span>{hint}</span>
                </div>
            )}
            {actionLink && (
                <div className="webshop-select__action-link">
                    <LinkButton
                        className="webshop-select__action-link-text"
                        title={actionLink.title}
                        href={actionLink.href}
                        target={actionLink.target}
                        textOnly
                    />
                </div>
            )}
        </div>
    )
}

export default WebshopSelect
